import { MainView } from './MainView';
export { MainView };
